import React from "react";
const projects = [{
  id: 1,
  title: "Digital Transformation in Urban Infrastructure",
  description: "Advanced BIM modeling and IoT integration for smart city development.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_bim_infrastructure.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_bim_infrastructure.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_bim_infrastructure.png-wvc-sizes"
  }
}, {
  id: 2,
  title: "Sustainable Concrete Technology Research",
  description: "Developing high-performance eco-friendly materials for modern construction.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_concrete_research.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_concrete_research.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_concrete_research.png-wvc-sizes"
  }
}, {
  id: 3,
  title: "Structural Integrity Monitoring Systems",
  description: "Real-time sensor networks for large-scale bridge and tunnel safety.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_structural_monitoring.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_structural_monitoring.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_structural_monitoring.png-wvc-sizes"
  }
}, {
  id: 4,
  title: "Automated Construction Site Management",
  description: "AI-driven logistics and safety monitoring for complex building projects.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_site_management.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_site_management.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_site_management.png-wvc-sizes"
  }
}, {
  id: 5,
  title: "Energy Efficient Building Envelope Design",
  description: "Innovative thermal insulation solutions for tropical climate zones.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_energy_efficiency.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_energy_efficiency.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_energy_efficiency.png-wvc-sizes"
  }
}, {
  id: 6,
  title: "Geotechnical Engineering Innovation",
  description: "Advanced soil stabilization techniques for high-rise foundations.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_geotechnical_innovation.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_geotechnical_innovation.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_geotechnical_innovation.png-wvc-sizes"
  }
}, {
  id: 7,
  title: "Modular Construction Systems Development",
  description: "Prefabricated structural components for rapid housing deployment.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_modular_systems.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_modular_systems.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_modular_systems.png-wvc-sizes"
  }
}, {
  id: 8,
  title: "Hydraulic Engineering & Water Management",
  description: "Smart drainage systems and flood prevention technology transfer.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_hydraulic_engineering.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_hydraulic_engineering.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_hydraulic_engineering.png-wvc-sizes"
  }
}, {
  id: 9,
  title: "Green Building Certification Consulting",
  description: "Technical support for LEED and LOTUS standard compliance.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_green_building.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_green_building.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_green_building.png-wvc-sizes"
  }
}, {
  id: 10,
  title: "Advanced Steel Structure Optimization",
  description: "Computational design for long-span industrial facilities.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_steel_optimization.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_steel_optimization.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_steel_optimization.png-wvc-sizes"
  }
}, {
  id: 11,
  title: "Waste-to-Resource Technology Transfer",
  description: "Recycling construction debris into high-value building materials.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_waste_recycling.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_waste_recycling.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_waste_recycling.png-wvc-sizes"
  }
}, {
  id: 12,
  title: "Digital Twin for Heritage Conservation",
  description: "3D laser scanning and digital preservation of historic structures.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_heritage_digital_twin.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_heritage_digital_twin.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_heritage_digital_twin.png-wvc-sizes"
  }
}, {
  id: 13,
  title: "Seismic Resilience Engineering",
  description: "Vibration control and earthquake-resistant design solutions.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_seismic_engineering.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_seismic_engineering.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_seismic_engineering.png-wvc-sizes"
  }
}, {
  id: 14,
  title: "Smart Lighting & Automation Systems",
  description: "Integrated building management systems for energy optimization.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_smart_lighting.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_smart_lighting.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_smart_lighting.png-wvc-sizes"
  }
}];
export default function ProjectsGrid() {
  return <section data-section-id="258157" id="researchinnovationprojects" className="bg-background text-foreground py-12 md:py-24">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {projects.length > 0 ? projects.map((project, i) => <div key={project.id} data-index={i} className="group relative aspect-video overflow-hidden rounded-md bg-muted shadow-md transition-all duration-300 hover:shadow-xl">
                <img src={project.image.src} data-wvc-srcset={project.image.srcset} data-wvc-sizes={project.image.sizes} alt={project.title} className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
                <div className="absolute inset-0 bg-primary/60 transition-opacity duration-300 group-hover:bg-primary/70" />
                <div className="absolute bottom-6 left-6 right-6 text-primary-foreground">
                  <span className="mb-2 inline-block bg-accent px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest text-accent-foreground rounded-md">
                    Innovation
                  </span>
                  <p className="mb-2 text-sm font-default line-clamp-3 text-primary-foreground/80">
                    {project.description}
                  </p>
                  <h3 className="font-default text-xl font-bold leading-tight text-primary-foreground">
                    {project.title}
                  </h3>
                </div>
              </div>) : <div className="col-span-full py-20 text-center">
              <p className="font-default text-lg text-muted-foreground">No research projects found in this category.</p>
            </div>}
        </div>
      </div>
    </section>;
}